import { IContact } from 'components/ContactForm';
import { useState } from 'react';
import parsePhoneNumber from 'libphonenumber-js';

const validationErrors = {
  name: 'Ange ett namn',
  company: 'Ange ett företag',
  email: 'Ange en giltig e-postadress',
  phone: 'Ange ett giltigt telefonnummer',
};

const useContactForm = () => {
  const [contact, setContact] = useState<IContact>({
    name: '',
    company: '',
    email: '',
    phone: '',
    other: '',
  });

  const [contactErrors, setContactErrors] = useState<IContact>({
    name: '',
    company: '',
    email: '',
    phone: '',
    other: '',
  });

  const [isTouched, setIsTouched] = useState(false);

  const sanitizePhoneInput = (input: string) => {
    return input.replace(/[^0-9+]/g, '');
  };

  const handleContactChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;

    let sanitizedValue = value;
    if (name === 'phone') {
      sanitizedValue = sanitizePhoneInput(value);
    }

    setContact((prevContact) => ({
      ...prevContact,
      [name]: sanitizedValue,
    }));

    if (isTouched) {
      validateField(name, sanitizedValue);
    }
  };

  const validateField = (name: string, value: string) => {
    let error = '';
    switch (name) {
      case 'name':
        error = value ? '' : validationErrors.name;
        break;
      case 'company':
        error = value ? '' : validationErrors.company;
        break;
      case 'email':
        error = /\S+@\S+\.\S+/.test(value) ? '' : validationErrors.email;
        break;
      case 'phone':
        try {
          const phoneNumber = parsePhoneNumber(value, 'SE');
          error = phoneNumber && phoneNumber.isValid() ? '' : validationErrors.phone;
        } catch {
          error = validationErrors.phone;
        }
        break;
      default:
        break;
    }

    setContactErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));
  };

  const validateContactForm = () => {
    setIsTouched(true);

    const errors = {
      name: contact.name ? '' : validationErrors.name,
      company: contact.company ? '' : validationErrors.company,
      email: /\S+@\S+\.\S+/.test(contact.email) ? '' : validationErrors.email,
      phone: (() => {
        try {
          const phoneNumber = parsePhoneNumber(contact.phone, 'SE');
          return phoneNumber && phoneNumber.isValid() ? '' : validationErrors.phone;
        } catch {
          return validationErrors.phone;
        }
      })(),
      other: '',
    };

    setContactErrors(errors);
    return Object.values(errors).every((error) => !error);
  };

  return {
    contact,
    contactErrors,
    handleContactChange,
    validateContactForm,
  };
};

export default useContactForm;
